<template>
    <div :id="id" class="row">
      <LmGooglePlacesAutocomplete
        class="col-12 col-md-8"
        label="Direccion inicial"
        @placeChanged="placeChanged"
        :value="component.componentProps.initialPosition.formattedAddress"
      />
      <LmTextInput
        :id="id + 'label'"
        help="Titulo del campo de busqueda."
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="$emit('input', component)"
        :label="$t('title')"
        placeholder="Dirección"
      />
      <LmTextInput
        v-if="validateSuperUser"
        class="col-12 col-md-4"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        :label="$t('name')"
        :placeholder="$t('name')"
        :help="$t('comp_name_help')"
      />
      <LmTextInput
        :id="id + 'height'"
        help="Este ajuste no se podrá ver correctamente en la vista previa, por que el mapa necesita conocer la altura para poder mostrarse de manera correcta. Cuando el formulario sea guardado y visto en su vista final se verá correctamente."
        class="col-12 col-md-4"
        v-model="component.componentProps.height"
        @input="$emit('input', component)"
        :label="$t('map_height')"
        placeholder="400px"
      />
      <div class="col-12 col-md-4">
        <label for="zoom">Zoom</label>
        <b-form-input
          id="zoom"
          v-model="component.componentProps.zoom"
          @input="$emit('input', component)"
          type="range"
          min="0"
          max="18"/>
          <div class="mt-2">Zoom: {{ component.componentProps.zoom }}</div>
      </div>
      <LmSelect
        :id="id + 'tiles'"
        class="col-12 col-md-4"
        v-model="component.componentProps.tile"
        :options="{
          content: [
            {value: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',text: 'Mapa'},
            {value: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', text: 'Satélite'},
            {value: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', text: 'Topográfico'}
          ]
        }"
        :label="$t('peview')"
        @input="$emit('input', component)"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
import LmGooglePlacesAutocomplete from '@/components/LmGooglePlacesAutocomplete.vue'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  components: {
    LmGooglePlacesAutocomplete
  },
  methods: {
    placeChanged (place) {
      console.log(this.component)
      const latLong = [
        place.geometry.location.lat(),
        place.geometry.location.lng()
      ]
      this.component.componentProps.initialPosition.latLong = latLong
      this.component.componentProps.initialPosition.formattedAddress = place.formatted_address
      this.$emit('input', this.component)
    }
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
